module.exports = __webpack_public_path__ + "media/images/project/down-arrow-circle-257b9c42c618e18f1b92fa82f06aa3ac.svg";